import { render, staticRenderFns } from "./newPassword.vue?vue&type=template&id=690c7b0a"
import script from "./newPassword.ts?vue&type=script&lang=js&external"
export * from "./newPassword.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports